export const loginActions = {
  apiAction: "LOGIN_FETCH_DATA",
  apiActionSet: "LOGIN_SET_DATA",
  apiActionError: "LOGIN_FETCH_DATA_ERROR",
  LOGOUT_USER: "LOGOUT_USER",
  LOGOUT_USER_SUCCESS: "LOGOUT_USER_SUCCESS",
  LOGOUT_USER_FAILED: "LOGOUT_USER_FAILED",
  GET_LOGIN_DETAILS_REQUEST: "GET_LOGIN_DETAILS_REQUEST",
  GET_LOGIN_DETAILS_SUCCESS: "GET_LOGIN_DETAILS_SUCCESS",
  SET_LOGIN_DETAILS_ERROR: "SET_LOGIN_DETAILS_ERROR",
  LOGIN_ACTION: "LOGIN_ACTION",
  LOGIN_ACTION_SUCCESS: "LOGIN_ACTION_SUCCESS",
  LOGIN_ACTION_FAIL: "LOGIN_ACTION_FAIL",
  GET_AUTH_TOKENS: "GET_AUTH_TOKENS",
  GET_AUTH_TOKEN_SUCCESS: "GET_AUTH_TOKEN_SUCCESS",
  GET_AUTH_TOKEN_FAIL: "GET_AUTH_TOKEN_FAIL",
  SET_INVALID_TENANT_URL: "SET_INVALID_TENANT_URL",
  LOCAL_USER_SIGNUP: "LOCAL_USER_SIGNUP",
  LOCAL_USER_LOGIN: "LOCAL_USER_LOGIN",
  LOCAL_USER_FORGOT_PASSWORD: "LOCAL_USER_FORGOT_PASSWORD",
  LOCAL_USER_RESET_PASSWORD: "LOCAL_USER_RESET_PASSWORD",
  VERIFY_USER_ON_LOGIN: "VERIFY_USER_ON_LOGIN",
  SET_LOCAL_USER_TOKEN: "SET_LOCAL_USER_TOKEN",
  SET_LOCAL_USER_SIGNUP_ERROR: "SET_LOCAL_USER_SIGNUP_ERROR",
  SET_LOCAL_USER_SIGNUP_SUCCESS: "SET_LOCAL_USER_SIGNUP_SUCCESS",
  SET_LOCAL_USER_LOGIN_ERROR: "SET_LOCAL_USER_LOGIN_ERROR",
  SET_LOCAL_USER_FORGOT_PASSWORD_ERROR: "SET_LOCAL_USER_FORGOT_PASSWORD_ERROR",
  SET_LOCAL_USER_RESET_PASSWORD_ERROR: "SET_LOCAL_USER_RESET_PASSWORD_ERROR",
  SET_LOCAL_USER_FORGOT_PASSWORD_SUCCESS: "SET_LOCAL_USER_FORGOT_PASSWORD_SUCCESS",
  SET_LOCAL_USER_RESET_PASSWORD_SUCCESS: "SET_LOCAL_USER_RESET_PASSWORD_SUCCESS",
  SET_IDP_TOKEN: "SET_IDP_TOKEN",
  GET_IDP_TOKEN: "GET_IDP_TOKEN",
  VERIFY_LOCAL_USER: "VERIFY_LOCAL_USER",
  VERIFIED_LOCAL_USER: "VERIFIED_LOCAL_USER",
  INVALID_LOCAL_USER: "INVALID_LOCAL_USER",
  VERIFIED_WORKSPACE_LOCAL_USER: "VERIFIED_WORKSPACE_LOCAL_USER",
  INVALID_WORKSPACE_LOCAL_USER: "INVALID_WORKSPACE_LOCAL_USER",
  WORKSPACE_LOCAL_USER_LOGIN: "WORKSPACE_LOCAL_USER_LOGIN",
  WORKSPACE_LOCAL_USER_LOGIN_SUCCESS: "WORKSPACE_LOCAL_USER_LOGIN_SUCCESS",
  WORKSPACE_LOCAL_USER_LOGIN_ERROR: "WORKSPACE_LOCAL_USER_LOGIN_ERROR",
  REDIRECT: "REDIRECT",
};
